<ng-template [ngIf]="metaSelect">
  <mat-toolbar class="dialog-title">
    <span>{{titulo}} {{metaSelect.nombreDinamico}}</span>
    <div (click)="cerrar()" class="close-dialog">
      <i class="fas fa-times"></i>
    </div>
  </mat-toolbar>

  <div mat-dialog-content>
    <ng-template [ngIf]="objetivosMultiLevelList.length>0">
      <div *ngFor="let confPlan of objetivosMultiLevelList;let i = index">
        <mat-form-field appearance="outline" style="display: block; ">
          <mat-label>{{confPlan.nombre}}<span style="color: red;">*</span></mat-label>
          <mat-select (selectionChange)="seleccionarObjetivo($event,i)" required>
            <mat-option></mat-option>
            <mat-option *ngFor="let objetivo of confPlan.objetivos" [value]="objetivo">
              {{objetivo.nombre}}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>
    </ng-template>

    <mat-form-field appearance="outline">
      <mat-label>Código<span style="color: red;">*</span></mat-label>
      <input matInput [(ngModel)]="metaSelect.codigo" required>
    </mat-form-field>

    <mat-form-field appearance="outline">
      <mat-label>Descripción<span style="color: red;">*</span></mat-label>
      <textarea matInput [(ngModel)]="metaSelect.descripcion" matTextareaAutosize matAutosizeMinRows=3 matAutosizeMaxRows=15 required></textarea>
    </mat-form-field>


      <div style="margin-top: 5px">
        <mat-label class="custom-label">Responsable(s) </mat-label><button  mat-raised-button class="btn_olive" (click)="abrirAddResponsable()">+</button>
          <div *ngFor="let responsableMeta of responsableMetaList">
            <div class="div-unidad-organica">
              <span style="font-size: 13px;">
                <ul>
                  <li style="font-weight: bold;">{{responsableMeta.unidadOrganica.nombre}}</li>
                </ul>
              </span><i id="icon" (click)="deleteElement(responsableMeta)" class="icon-delete-div fas fa-times"></i>
            </div>
          </div>
      </div>

      <mat-form-field appearance="outline" class="field-meta-100">
        <mat-label>Normativa<span style="color: red;">*</span></mat-label>
        <mat-select [(ngModel)]="metaSelect.idNormativa" required>
          <mat-option></mat-option>
          <mat-option *ngFor="let normativa of catalogoNormativaList" [value]="normativa.id">
            {{normativa.descripcion}}
          </mat-option>
        </mat-select>
      </mat-form-field>

    <div style="margin-top: 20px">
      <mat-label class="custom-label">Forma de medición<span style="color: red;">*</span></mat-label>
      <div class="group-fields">
        <mat-radio-group [(ngModel)]="metaSelect.formaMedicion" required>
          <mat-radio-button [value]="this.constantes.FORMA_MEDICION_CANTIDAD">Por cantidad</mat-radio-button>
          <mat-radio-button [value]="this.constantes.FORMA_MEDICION_PORCENTAJE">Por porcentaje</mat-radio-button>
        </mat-radio-group>
      </div>
    </div>

    <div style="margin-top:10px">
      <mat-form-field appearance="outline" class="field-meta-50">
        <mat-label>Tipo de indicador <span style="color: red;">*</span></mat-label>
        <mat-select [(ngModel)]="metaSelect.idTipoIndicador" required>
          <mat-option></mat-option>
          <mat-option *ngFor="let indicador of catalogoIndicadorList" [value]="indicador.id">
            {{indicador.descripcion}}
          </mat-option>
        </mat-select>
      </mat-form-field>

      <mat-form-field appearance="outline" class="field-meta-50">
        <mat-label>Fórmula de cálculo<span style="color: red;">*</span></mat-label>
        <mat-select [(ngModel)]="metaSelect.idProcedimiento" required>
          <mat-option></mat-option>
          <mat-option *ngFor="let procedimiento of catalogoProcedimientoList" [value]="procedimiento.id">
            {{procedimiento.descripcion}}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>

    <div>
      <mat-form-field appearance="outline" class="field-meta-50">
        <mat-label>Fecha Inicio<span style="color: red;">*</span></mat-label>
        <input matInput [matDatepicker]="picker" [(ngModel)]="metaSelect.fechaInicio" required>
        <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
        <mat-datepicker #picker></mat-datepicker>
      </mat-form-field>
      <mat-form-field appearance="outline" class="field-meta-50">
        <mat-label>Fecha Final<span style="color: red;">*</span></mat-label>
        <input matInput [matDatepicker]="picker2" [(ngModel)]="metaSelect.fechaFin" required>
        <mat-datepicker-toggle matSuffix [for]="picker2"></mat-datepicker-toggle>
        <mat-datepicker #picker2></mat-datepicker>
      </mat-form-field>
    </div>
    <div>
      <mat-form-field  appearance="outline" style="width: 96%;">
        <mat-label>Sistema</mat-label>
        <textarea matInput [(ngModel)]="metaSelect.sistema" matTextareaAutosize matAutosizeMinRows=3 matAutosizeMaxRows=15></textarea>
      </mat-form-field>
      <mat-form-field appearance="outline" style="width: 96%;">
        <mat-label>Enlace</mat-label>
        <textarea matInput [(ngModel)]="metaSelect.enlace" matTextareaAutosize matAutosizeMinRows=3 matAutosizeMaxRows=15></textarea>
      </mat-form-field>
      <mat-form-field appearance="outline" class="field-meta-50">
        <mat-label>Frecuencia<span style="color: red;">*</span></mat-label>
        <mat-select [(ngModel)]="metaSelect.idFrecControl" required>
          <mat-option></mat-option>
          <mat-option *ngFor="let frecuencia of frecuenciaControlList" [value]="frecuencia.codigo">
            {{frecuencia.descripcion}}
          </mat-option>
        </mat-select>
      </mat-form-field>
      <mat-form-field appearance="outline" class="field-meta-50">
        <mat-label>Linea de base</mat-label>
        <input matInput [(ngModel)]="metaSelect.lineaBase" type="number" min=0>
      </mat-form-field>
      <mat-form-field appearance="outline" class="field-meta-100">
        <mat-label>Fuente<span style="color: red;">*</span></mat-label>
        <textarea matInput [(ngModel)]="metaSelect.fuente" matTextareaAutosize matAutosizeMinRows=7 matAutosizeMaxRows=21 required></textarea>
      </mat-form-field>
    </div>
    <div style="padding-left: 4px;">
        <mat-checkbox [(ngModel)]="metaSelect.esAcumulativo"></mat-checkbox>
        <mat-label style="padding-right: 10px;padding-left: 3px">Indicador acumulativo</mat-label>
    
        <mat-checkbox [(ngModel)]="metaSelect.contieneLengua"></mat-checkbox>
        <mat-label style="padding-right: 10px;padding-left: 3px">Registrar lengua</mat-label>
      
    </div>
  </div>

  <div class="dialog-buttons">
    <button mat-raised-button [disabled]="validarCampos()" class="btn_olive" (click)="guardarMeta()">Registrar</button>&nbsp;
    <button mat-raised-button class="btn_danger" (click)="cerrar()">Cancelar</button>
  </div>

</ng-template>
